<template>
<section class="grid grid-cols-2 grid-flow-col gap-2 ">
    <section class="p-3">
        <div class="flex">
            <h3 class="text-white text-xl font-bold uppercase">Coordinate data (GPX)</h3>
            <span v-if="form.recentlySuccessful" class="ml-3 mt-1 text-white">
                Updated
            </span>
        </div>
        <div v-if="this.$page.props.errors.coordinate_data != null" class="block">
            <span v-for="error in Object.values($page.props.errors)" class="errormessage">
            {{ error }}</span>
        </div>
        <p v-if="!showCoortinateDataAddForm" class="text-white mb-4 text-xs">Coordinate data can only be added in fallback language</p>
    <CoordinateDataAdd
        v-if="showCoortinateDataAddForm"
        :form="form"
        :changeUploadBoxState="changeUploadBoxState"
        :errors="errors"
    />
    </section>
<div>
    <WaypointItem
        v-for="item in this.waypoints"
        :key="item.id"
        :item="item"
        :form="form"
        :changeUploadBoxState="changeUploadBoxState"
        :current_language="current_language"
        :deleteWaypoint="deleteWaypoint"
    />
</div>
</section>

<DeleteWaypointsModal
:showModal="deleteWaypointsModal"
:hideModalFn="() => deleteWaypointsModal = false"
:fallback_language="fallback_language"
:current_language="current_language"
:changeLanguage="changeLanguage"
:delete_coordinates_form="delete_coordinates_form"
/>

</template>

<script>
import CoordinateDataAdd from './CoordinateDataAdd';
import WaypointItem from './WaypointItem';
import DeleteWaypointsModal from './DeleteWaypointsModal';
import {
    unlinkCoordinateDataItemByLanguage,
    unlinkCoordinateDataItemsInAllLanguages,
    hasFileInNotFallbackLanguage
} from '@/Pages/GlobalHelpers';

export default {
    components: {
        CoordinateDataAdd,
        WaypointItem,
        DeleteWaypointsModal,
    },
    props: ['form',
        'changeUploadBoxState',
        'waypoints',
        'errors',
        'current_language',
        'fallback_language',
        'changeLanguage',
        'showPreventFallbackLangModal',
        'deleteInAllLanguagesCoordinateDataFormRunning',
        'hidePreventFallbackLangModal'
    ],
    data(){
        return{
            delete_coordinates_form: this.$inertia.form({
              _method: 'POST',
              waypoint_id: null,
              waypoints_resource_id: this.item && this.item.waypoints_resource.id,
              current_language: this.$page.props.tour.data.fallback_language,
              fallback_language: this.$page.props.tour.data.fallback_language,
            }),
            showCoortinateDataAddForm: true,
            deleteWaypointsModal: false,
            item_for_delete: null,
            //======
            files_for_delete_in_languages:[],
            number_of_language_for_file_to_delete: null,
        }
    },
    watch:{
        current_language: function (newState, oldState){
            if(newState == this.fallback_language){
                this.showCoortinateDataAddForm = true;
            } else {
                this.showCoortinateDataAddForm = false;
            }
            this.delete_coordinates_form.current_language = newState;
        },
        deleteInAllLanguagesCoordinateDataFormRunning: function(newState, oldState){
            if(newState == true && this.delete_coordinates_form.waypoint_id){
                this.unlinkCoordinateDataItemsInAllLanguages();
            }
        }
    },
    methods:{
        showDeleteWaypointsModal(){
            this.deleteWaypointsModal = true;
        },
        deleteWaypoint(e, itemId){
            const item_for_delete = this.waypoints.filter(el => el.id == itemId)[0];
            this.delete_coordinates_form.waypoint_id = item_for_delete.id;
            this.delete_coordinates_form.waypoints_resource_id = item_for_delete.waypoints_resource.id;

            if(this.hasFileInNotFallbackLanguage('waypoints') == true)
            {
                this.showPreventFallbackLangModal('waypoints');
                return;
            }
            this.showDeleteWaypointsModal();
        },
        hasFileInNotFallbackLanguage:hasFileInNotFallbackLanguage,
        unlinkCoordinateDataItemsInAllLanguages:unlinkCoordinateDataItemsInAllLanguages,
        unlinkCoordinateDataItemByLanguage:unlinkCoordinateDataItemByLanguage
    }
}
</script>
